import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, GlobalStyles } from '@mui/material';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

const DashboardLayout = ({ menu, title, isMobile }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopCollapsed, setDesktopCollapsed] = useState(true);
  const [hovered, setHovered] = useState(false);

  const isExpanded = !desktopCollapsed || hovered;
  const sidebarWidth = isExpanded ? 240 : 72;

  return (
    <>
      {/* Global scrollbar styles */}
      <GlobalStyles
        styles={{
          '*::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },
          '*::-webkit-scrollbar-track': {
            backgroundColor: '#f5f5f5',
            borderRadius: '4px',
          },
          '*::-webkit-scrollbar-thumb': {
            backgroundColor: '#FFD600',
            borderRadius: '4px',
            '&:hover': {
              backgroundColor: '#ffcc00',
            },
          },
        }}
      />
      
      <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
        {/* Sidebar - FLOATING */}
        <Box
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <Sidebar
            menu={menu}
            isMobile={isMobile}
            mobileOpen={mobileOpen}
            setMobileOpen={setMobileOpen}
            desktopCollapsed={desktopCollapsed}
            setDesktopCollapsed={setDesktopCollapsed}
            hovered={hovered}
            setHovered={setHovered}
          />
        </Box>

        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: '100%',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',  // ← Enable vertical scrolling
          }}
        >
          <TopBar
            title={title}
            isMobile={isMobile}
            onMenuClick={() => setMobileOpen(true)}
            sidebarWidth={sidebarWidth}
          />
          <Box
            sx={{
              p: 0,
              flexGrow: 1,
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DashboardLayout;